function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import React, { useState, useEffect, useRef } from "react";
import { Carousel } from "@xo-union/ui-carousel";
import { H4 } from "@xo-union/tk-ui-typography";
import { compose } from "@xo-union/react-css-modules";
import LazyloadImage from "../LazyLoadImage/index.js";
import PrevArrow from "./components/Arrows/prevArrow.js";
import NextArrow from "./components/Arrows/nextArrow.js";
import { useTrack } from "@tkww/ads-content-component-analytics/react";
import getTrackingData from "../../data/index.js";
import styles from "./styles.css";
import { mapCollectionCarouselData, ProductImpression } from "../../utils/analytics.js";
export default function CollectionCarousel(_ref) {
  var ProductCardsInfo = _ref.ProductCardsInfo,
    mobileSlidesToShow = _ref.mobileSlidesToShow,
    desktopSlidesToShow = _ref.desktopSlidesToShow,
    mobileWidth = _ref.mobileWidth,
    desktopWidth = _ref.desktopWidth,
    mobileHeight = _ref.mobileHeight,
    desktopHeight = _ref.desktopHeight,
    heading = _ref.heading,
    collection = _ref.collection,
    gutter = _ref.gutter,
    isMobile = _ref.isMobile;
  var _useState = useState(isMobile ? mobileSlidesToShow : desktopSlidesToShow),
    _useState2 = _slicedToArray(_useState, 2),
    slidesToShow = _useState2[0],
    setSlidesToShow = _useState2[1];
  var _useState3 = useState(isMobile ? {
      width: mobileWidth
    } : {
      width: desktopWidth
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    cardStyle = _useState4[0],
    setCardStyle = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    visibleSlides = _useState6[0],
    setVisibleSlides = _useState6[1];
  var slideRefs = useRef([]);
  var styleMapper = compose(styles);
  useEffect(function () {
    var _context2;
    var observer = new IntersectionObserver(function (entries) {
      var _context;
      var visible = _mapInstanceProperty(_context = _filterInstanceProperty(entries).call(entries, function (entry) {
        return entry.isIntersecting;
      })).call(_context, function (entry) {
        return Number(entry.target.dataset.index);
      });
      setVisibleSlides(visible);
    }, {
      threshold: 0.5
    } // Adjust based on when you consider a slide "visible"
    );

    _forEachInstanceProperty(_context2 = slideRefs.current).call(_context2, function (slide) {
      if (slide) observer.observe(slide);
    });
    return function () {
      var _context3;
      _forEachInstanceProperty(_context3 = slideRefs.current).call(_context3, function (slide) {
        if (slide) observer.unobserve(slide);
      });
    };
  }, []);
  useEffect(function () {
    if (visibleSlides.length > 0) {
      _forEachInstanceProperty(visibleSlides).call(visibleSlides, function (index) {
        var slideData = ProductCardsInfo[index];
        if (slideData) {
          var trackingData = getTrackingData("productImpression");
          var data = mapCollectionCarouselData(slideData);
          ProductImpression(_objectSpread(_objectSpread({}, trackingData.data), data));
        }
      });
    }
  }, [visibleSlides, ProductCardsInfo]);
  useEffect(function () {
    var onWindowResize = function onWindowResize() {
      setSlidesToShow(isMobile ? mobileSlidesToShow : desktopSlidesToShow);
      setCardStyle(isMobile ? {
        width: 154
      } : {
        width: 260
      });
    };
    window.addEventListener("resize", onWindowResize);
    return function () {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);
  var track = useTrack();
  var handleClickThroughProduct = function handleClickThroughProduct(e) {
    var defaultParams = JSON.parse(e.target.closest("a").getAttribute("data-analytics"));
    if (defaultParams) track(defaultParams);
  };
  var extractIdFromUrl = function extractIdFromUrl(product) {
    var match = "";
    if (collection === "more_in_this") {
      var regex = /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})/i;
      match = product.image.match(regex);
      return match ? match[0] : null;
    } else {
      match = isMobile ? product.mobile_img_id : product.desktop_img_id;
    }
    return match;
  };
  var nextButton = isMobile ? function () {
    return null;
  } : NextArrow;
  var prevButton = isMobile ? function () {
    return null;
  } : PrevArrow;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.moreInThisCollectionContainer,
    "data-slide-to-show": slidesToShow
  }, /*#__PURE__*/React.createElement(H4, {
    as: "h2",
    className: styles.sectionTitle + " ".concat(collection === "more_in_this" ? styles.moreInThisCollection : styles.latestCollection)
  }, heading), /*#__PURE__*/React.createElement(Carousel, {
    classes: styleMapper,
    gutter: gutter,
    minSlideWidth: cardStyle.width,
    maxSlideWidth: cardStyle.width,
    renderNextButton: nextButton,
    renderPrevButton: prevButton,
    pagination: "auto"
  }, _mapInstanceProperty(ProductCardsInfo).call(ProductCardsInfo, function (product, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      ref: function ref(el) {
        return slideRefs.current[index] = el;
      },
      "data-index": index,
      className: "".concat(styles.collectionCard, " carousel-slide"),
      style: cardStyle,
      "data-analytics": _JSON$stringify({
        selection: "product",
        userDecisionArea: collection,
        destinationUrl: product.linking_slug,
        product: product
      }),
      onClick: handleClickThroughProduct
    }, /*#__PURE__*/React.createElement("a", {
      id: "product-link-".concat(product.id),
      className: styles.collectionLink,
      href: product.linking_slug,
      tabIndex: -1
    }, /*#__PURE__*/React.createElement(LazyloadImage, {
      containerClassName: styles.moreInThisCollectionImageContainer,
      image: extractIdFromUrl(product),
      alt: product.alt,
      desktopWidth: cardStyle.width,
      mobileWidth: cardStyle.width,
      desktopHeight: desktopHeight,
      mobileHeight: mobileHeight,
      isLeadImage: false,
      img_ratio: product.img_ratio,
      showLoader: true
    }), product.headline && /*#__PURE__*/React.createElement("div", {
      className: styles.panelHeading
    }, /*#__PURE__*/React.createElement("p", {
      className: collection === "latest_collection" ? styles.latestCollectionTitle : ""
    }, product.headline))));
  })));
}